<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page-iii"></a><strong>EQUATIONS</strong> <em>OF</em> <strong>LIFE</strong></h1>
<h1 class="author">SIMON MORDEN</h1>
<p class="pub"><img alt="image" src="images/Art_Plogo.jpg"/></p>
<p class="city"><strong><a href="http://www.orbitbooks.net" target="_blank">www.orbitbooks.net</a></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?40322130